class FooterAccordion extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.mobile = window.matchMedia('(max-width: 749px)');
    this.block = this.closest('.footer-block');
    this.mobileOpen = false;
    this.onBreakpointChange = () => {
      this.details.open = this.mobile.matches ? this.mobileOpen : true;
    };
    this.onToggle = () => {
      if (this.mobile.matches) this.mobileOpen = this.details.open;
    };
    this.onBlockSelect = () => {
      this.details.open = true;
    };
    this.mobile.addEventListener('change', this.onBreakpointChange);
    this.details.addEventListener('toggle', this.onToggle);
    this.block.addEventListener('shopify:block:select', this.onBlockSelect);
    this.onBreakpointChange();
  }

  disconnectedCallback() {
    this.mobile.removeEventListener('change', this.onBreakpointChange);
    this.details.removeEventListener('toggle', this.onToggle);
    this.block.removeEventListener('shopify:block:select', this.onBlockSelect);
  }
}

customElements.define('footer-accordion', FooterAccordion);
